module.exports = __webpack_public_path__ + "img/canteen.744d268.png";